import React, { useState } from 'react';
import {
  Accordion,
  AccordionImageList,
  AccordionImageListItem,
  AccordionImageListItemContainer,
} from 'festo-react-ui-kit';
import { NavLink } from 'react-router-dom';
import { useAppDispatch } from '../../app/hooks';
import useTranslation from '../../features/translation/hooks/useTranslation';

import './AccordionArea.scss';
import { AccordionItem } from './interfaces';
import { updateFilter } from '../../features/filter/filterSlice';
import { econdaClickEvent } from '../../Econda';
import {useLocation} from "react-router";

enum TranslationKeys {
  BUTTON_LABEL_IMAGE_LIST = 'buttonLabelImageList',
}

interface AccordionAreaProps {
  group: AccordionItem[];
}

const AccordionArea: React.FC<AccordionAreaProps> = ({ group }) => {
  const dispatch = useAppDispatch();
  const t = useTranslation();
  const { pathname } = useLocation();
  const [expanded, setExpanded] = useState<number | null>(null);

  const handleAccordionClick =
    (applicationId: number, applicationTitle: string) =>
    (currentAccordionExpanded: boolean): void => {
      setExpanded(currentAccordionExpanded ? applicationId : -1);
      econdaClickEvent(pathname, 'general', 'main accordion', `${applicationTitle}`);
    };

 /*  const onUpdateMotionType = (
    { filterValue }: { filterValue: string },
    { filterName }: { filterName: string },
    { applicationTitle }: { applicationTitle: string },
   ) => {
    dispatch(
      updateFilter({
        name: 'motionType',
        newValue: filterValue,
      }),
    ); 
  };*/

  return (
    <div className="ems-accordion-area">
      {group.length > 0 &&
        group.map((gr) => (
          <Accordion
            key={gr.key}
            expanded={expanded === gr.key}
            onClick={handleAccordionClick(gr.key, gr.title)}
            title={t(gr.title)}
            description={t(gr.description)}
            icon={gr.icon}
            data-testid={`content-accordion-test-${gr.title}`}
          >
            <AccordionImageList data-testid={`content-accordion-${gr.title}-imageList`}>
              {gr.children.length > 0 &&
                gr.children.map((child) => {
                  return (
                    <AccordionImageListItemContainer key={child.name} >
                      <NavLink
                        onClick={() =>{
                          dispatch(
                            updateFilter({
                              name: 'motionType',
                              newValue: child.filterValue,
                            }),
                          );
                          const trimFilterName = child.name.slice(7);
                          econdaClickEvent(pathname, 'main accordion', `${gr.title}`, `${trimFilterName}`);
                          }  
                        }
                        to={child.url.toLocaleLowerCase()}
                      >
                        <AccordionImageListItem
                          title={t(child.name)}
                          description={t(child.description)}
                          src={child.img || ''}
                          buttonLabel={t(TranslationKeys.BUTTON_LABEL_IMAGE_LIST)}
                        />
                      </NavLink>
                    </AccordionImageListItemContainer>
                  );
                })}
            </AccordionImageList>
          </Accordion>
        ))}
    </div>
  );
};

export default AccordionArea;
